(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animations"] && !Shopify.designMode) return;
  try {
    // Shared, ref-counted scroll lock so multiple overlays (menu drawer, cart drawer) cannot
  // clobber each other's body-overflow reset.
  if (!window.MetryScrollLock) {
    window.MetryScrollLock = (function () {
      var count = 0;
      return {
        lock: function () { count++; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; },
        unlock: function () { count = Math.max(0, count - 1); if (count === 0) { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; } }
      };
    })();
  }

  (function () {
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('reveal-in');
      });
    }

    function initReveal() {
      var els = document.querySelectorAll('[data-reveal]');
      if (reduce || !('IntersectionObserver' in window)) {
        revealAll();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initImageFade() {
      document.querySelectorAll('img.lazy-fade').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
        }
      });
    }

    function start() { initReveal(); initImageFade(); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-code')) {
    customElements.define('gift-code', class extends HTMLElement {
      connectedCallback() {
        const b = this.querySelector('[data-code]');
        if (b) b.addEventListener('click', () => {
          if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.code);
          b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-blog-pagination"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-blog-results')) {
    class MtBlogResults extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced === 'true') return;
        this.dataset.enhanced = 'true';
        this.loadController = null;
        this.loadSequence = 0;
        this.entryFrame = null;
        this.entryCleanupTimer = null;
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.loadController?.abort();
        if (this.entryFrame) window.cancelAnimationFrame(this.entryFrame);
        if (this.entryCleanupTimer) window.clearTimeout(this.entryCleanupTimer);
      }

      animateNewItems(newItems, sequence) {
        if (!newItems.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (this.entryFrame) window.cancelAnimationFrame(this.entryFrame);
        if (this.entryCleanupTimer) window.clearTimeout(this.entryCleanupTimer);
        newItems.forEach((item, index) => {
          item.dataset.blogCardEnter = 'preparing';
          item.style.setProperty('--mt-blog-card-entry-delay', `${Math.min(index, 7) * 35}ms`);
        });
        this.entryFrame = window.requestAnimationFrame(() => {
          if (!this.isConnected || sequence !== this.loadSequence) return;
          newItems.forEach((item) => { item.dataset.blogCardEnter = 'entered'; });
          this.entryFrame = null;
          this.entryCleanupTimer = window.setTimeout(() => {
            if (!this.isConnected || sequence !== this.loadSequence) return;
            newItems.forEach((item) => {
              delete item.dataset.blogCardEnter;
              item.style.removeProperty('--mt-blog-card-entry-delay');
            });
            this.entryCleanupTimer = null;
          }, 620);
        });
      }

      async handleClick(event) {
        const loadMore = event.target.closest('[data-load-more]');
        if (!loadMore || this.dataset.loading === 'true') return;

        event.preventDefault();
        const shouldMoveFocus = event.detail === 0;
        this.loadController?.abort();
        this.loadController = new AbortController();
        const loadController = this.loadController;
        const loadSequence = this.loadSequence + 1;
        this.loadSequence = loadSequence;
        this.dataset.loading = 'true';
        loadMore.setAttribute('aria-busy', 'true');
        loadMore.setAttribute('aria-disabled', 'true');

        try {
          const nextUrl = new URL(loadMore.href, window.location.origin);
          nextUrl.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(nextUrl.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: loadController.signal,
          });
          if (!response.ok) throw new Error(`Blog page request failed: ${response.status}`);

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incomingResults = documentFragment.querySelector('mt-blog-results');
          const currentGrid = this.querySelector('[data-blog-grid]');
          const incomingGrid = incomingResults?.querySelector('[data-blog-grid]');
          const currentPagination = this.querySelector('[data-blog-pagination]');
          const incomingPagination = incomingResults?.querySelector('[data-blog-pagination]');

          if (!this.isConnected || loadSequence !== this.loadSequence || !incomingResults || !currentGrid || !incomingGrid || !currentPagination) {
            throw new Error('Blog page response did not contain the expected Section markup.');
          }

          const newItems = Array.from(incomingGrid.querySelectorAll('[data-blog-card-item]'));
          currentGrid.append(...newItems);
          this.animateNewItems(newItems, loadSequence);
          if (incomingPagination) {
            currentPagination.replaceWith(incomingPagination);
          } else {
            currentPagination.remove();
          }

          const status = this.querySelector('[data-blog-status]');
          if (status) {
            status.textContent = this.dataset.loadedMessage.replace('__count__', String(newItems.length));
          }
          if (shouldMoveFocus) {
            newItems[0]?.querySelector('a[href]')?.focus();
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          const status = this.querySelector('[data-blog-status]');
          if (status) status.textContent = this.dataset.failedMessage;
          loadMore.removeAttribute('aria-busy');
          loadMore.removeAttribute('aria-disabled');
        } finally {
          if (loadSequence === this.loadSequence) delete this.dataset.loading;
        }
      }
    }

    customElements.define('mt-blog-results', MtBlogResults);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-button-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-button-motion')) {
    class MtButtonMotion extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.onPointerOver = this.onPointerOver.bind(this);
        this.onPointerOut = this.onPointerOut.bind(this);
        this.addEventListener('pointerover', this.onPointerOver);
        this.addEventListener('pointerout', this.onPointerOut);
      }

      disconnectedCallback() {
        this.removeEventListener('pointerover', this.onPointerOver);
        this.removeEventListener('pointerout', this.onPointerOut);
        this.initialized = false;
      }

      onPointerOver(event) {
        const control = event.target.closest('.mt-button-motion__control');
        if (!control || control.closest('mt-button-motion') !== this || control.contains(event.relatedTarget)) return;

        const bounds = control.getBoundingClientRect();
        this.dataset.mtButtonMotionEnter = event.clientX - bounds.left <= bounds.width / 2 ? 'left' : 'right';

        if (control.classList.contains('mt-button-motion__control--pointer-fill')) {
          control.style.setProperty('--mt-button-motion-fill-x', `${event.clientX - bounds.left}px`);
          control.style.setProperty('--mt-button-motion-fill-y', `${event.clientY - bounds.top}px`);
          if (event.pointerType !== 'touch') control.classList.add('is-filled');
        }
      }

      onPointerOut(event) {
        const control = event.target.closest('.mt-button-motion__control--pointer-fill');
        if (!control || control.closest('mt-button-motion') !== this || control.contains(event.relatedTarget)) return;
        if (event.pointerType !== 'touch') control.classList.remove('is-filled');
      }
    }

    customElements.define('mt-button-motion', MtButtonMotion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-fast-product-lightbox-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-fast-product-lightbox')) {
    class MtFastProductLightbox extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.productRoot = this.closest('mt-fast-product');
        this.dialog = this.querySelector('[data-mt-fp-dialog="zoom"]');
        this.viewport = this.querySelector('[data-mt-fp-lightbox-viewport]');
        this.content = this.querySelector('[data-mt-fp-zoom-content]');
        this.controls = this.querySelector('[data-mt-fp-lightbox-controls]');
        this.currentNode = this.querySelector('[data-mt-fp-lightbox-current]');
        this.totalNode = this.querySelector('[data-mt-fp-lightbox-total]');
        this.status = this.querySelector('[data-mt-fp-lightbox-status]');
        this.entries = [];
        this.currentIndex = 0;
        this.intent = 0;
        this.scale = 1;
        this.panX = 0;
        this.panY = 0;
        this.pointerId = null;
        this.suppressClick = false;
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { capture: true, signal });
        this.viewport?.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.viewport?.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal });
        this.viewport?.addEventListener('pointerup', (event) => this.onPointerEnd(event), { signal });
        this.viewport?.addEventListener('pointercancel', (event) => this.onPointerEnd(event), { signal });
        this.dialog?.addEventListener('close', () => this.reset(), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.reset();
        this.initialized = false;
      }

      refreshEntries() {
        const seen = new Set();
        this.entries = Array.from(this.productRoot?.querySelectorAll('[data-mt-fp-media-id]') || []).reduce(
          (entries, slide) => {
            const id = String(slide.dataset.mtFpMediaId || '');
            if (slide.dataset.mtFpMediaType !== 'image' || !id || seen.has(id)) return entries;
            const media = slide.querySelector('picture') || slide.querySelector('.mt-fast-product__media-image');
            const image = media?.matches('img') ? media : media?.querySelector('img');
            if (!media || !image) return entries;
            seen.add(id);
            entries.push({ id, media, image });
            return entries;
          },
          []
        );
      }

      prepare(mediaId) {
        this.refreshEntries();
        if (!this.entries.length || !this.content) return false;
        const requestedIndex = this.entries.findIndex((entry) => entry.id === String(mediaId || ''));
        if (requestedIndex < 0) return false;
        return this.render(requestedIndex);
      }

      render(index) {
        if (!this.entries.length || !this.content) return false;
        const normalizedIndex = (index + this.entries.length) % this.entries.length;
        const entry = this.entries[normalizedIndex];
        const { media, image } = entry;
        if (!media?.isConnected || !image?.isConnected) return false;
        const renderIntent = ++this.intent;
        this.currentIndex = normalizedIndex;
        this.resetTransform();
        this.restoreMountedMedia();
        this.mountMedia(media, image);
        this.content.classList.add('is-loading');
        this.syncControls();
        this.waitForImage(image).then(() => {
          if (renderIntent === this.intent && image.isConnected) {
            this.content?.classList.remove('is-loading');
          }
        });
        return true;
      }

      mountMedia(media, image) {
        this.mountedPlaceholder = document.createComment('mt-fast-product-lightbox-source');
        this.mountedSourceParent = media.parentNode;
        this.mountedSourceNextSibling = media.nextSibling;
        this.mountedImageAttributes = {
          loading: image.getAttribute('loading'),
          draggable: image.getAttribute('draggable'),
          style: image.getAttribute('style'),
        };
        media.before(this.mountedPlaceholder);
        if (!image.complete) image.setAttribute('loading', 'eager');
        image.setAttribute('draggable', 'false');
        this.content.replaceChildren(media);
        this.mountedMedia = media;
        this.mountedImage = image;
      }

      restoreMountedMedia() {
        if (!this.mountedMedia) return;
        const { mountedMedia: media, mountedImage: image, mountedPlaceholder: placeholder } = this;
        const attributes = this.mountedImageAttributes || {};
        if (image) {
          if (attributes.loading === null) image.removeAttribute('loading');
          else image.setAttribute('loading', attributes.loading);
          if (attributes.draggable === null) image.removeAttribute('draggable');
          else image.setAttribute('draggable', attributes.draggable);
          if (attributes.style === null) image.removeAttribute('style');
          else image.setAttribute('style', attributes.style);
        }
        if (placeholder?.isConnected) {
          placeholder.replaceWith(media);
        } else if (this.mountedSourceParent?.isConnected) {
          this.mountedSourceParent.insertBefore(media, this.mountedSourceNextSibling || null);
        }
        this.mountedMedia = null;
        this.mountedImage = null;
        this.mountedPlaceholder = null;
        this.mountedSourceParent = null;
        this.mountedSourceNextSibling = null;
        this.mountedImageAttributes = null;
      }

      waitForImage(image) {
        const decoded = () => (typeof image.decode === 'function' ? image.decode().catch(() => false) : Promise.resolve(true));
        if (image.complete) return decoded();
        return new Promise((resolve) => {
          const complete = () => decoded().then(resolve);
          image.addEventListener('load', complete, { once: true });
          image.addEventListener('error', () => resolve(false), { once: true });
        });
      }

      syncControls() {
        const current = this.currentIndex + 1;
        const total = this.entries.length;
        if (this.currentNode) this.currentNode.textContent = String(current);
        if (this.totalNode) this.totalNode.textContent = String(total);
        if (this.controls) this.controls.hidden = total < 2;
        if (this.status) {
          this.status.textContent = (this.dataset.positionTemplate || 'Image __current__ of __total__')
            .replace('__current__', String(current))
            .replace('__total__', String(total));
        }
      }

      step(direction) {
        if (this.entries.length < 2) return;
        this.render(this.currentIndex + direction);
      }

      onClick(event) {
        if (!(event.target instanceof Element)) return;
        if (this.suppressClick) {
          window.clearTimeout(this.suppressClickTimer);
          this.suppressClick = false;
          if (event.detail !== 0) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
        }
        const step = event.target.closest('[data-mt-fp-lightbox-step]');
        if (step) {
          event.preventDefault();
          this.step(step.dataset.mtFpLightboxStep === 'previous' ? -1 : 1);
          return;
        }
        const image = this.content?.querySelector('img');
        const imageRect = image?.getBoundingClientRect();
        const hitImage = Boolean(
          event.target.closest('[data-mt-fp-zoom-content] img') ||
            (imageRect?.width &&
              imageRect?.height &&
              event.clientX >= imageRect.left &&
              event.clientX <= imageRect.right &&
              event.clientY >= imageRect.top &&
              event.clientY <= imageRect.bottom)
        );
        if (hitImage) {
          this.toggleZoom(event.clientX, event.clientY);
          return;
        }
        if (
          event.target.matches(
            '[data-mt-fp-lightbox-stage], [data-mt-fp-lightbox-viewport], [data-mt-fp-zoom-content]'
          )
        ) {
          this.querySelector('[data-mt-fp-close-dialog]')?.click();
        }
      }

      onKeydown(event) {
        if (!this.dialog?.open || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          event.stopPropagation();
          if (event.key === 'ArrowLeft') this.step(-1);
          if (event.key === 'ArrowRight') this.step(1);
          if (event.key === 'Home') this.render(0);
          if (event.key === 'End') this.render(this.entries.length - 1);
          return;
        }
        if (event.key === '+' || event.key === '=') {
          event.preventDefault();
          this.setZoom(3);
        }
        if (event.key === '-' || event.key === '0') {
          event.preventDefault();
          this.setZoom(1);
        }
      }

      onPointerDown(event) {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        window.clearTimeout(this.suppressClickTimer);
        this.suppressClick = false;
        this.pointerId = event.pointerId;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
        this.pointerPanX = this.panX;
        this.pointerPanY = this.panY;
        this.pointerMoved = false;
        this.viewport?.setPointerCapture?.(event.pointerId);
        if (this.scale > 1) this.classList.add('is-dragging');
      }

      onPointerMove(event) {
        if (event.pointerId !== this.pointerId) return;
        const deltaX = event.clientX - this.pointerStartX;
        const deltaY = event.clientY - this.pointerStartY;
        if (Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4) this.pointerMoved = true;
        if (this.scale <= 1) return;
        event.preventDefault();
        this.setPan(this.pointerPanX + deltaX, this.pointerPanY + deltaY);
      }

      onPointerEnd(event) {
        if (event.pointerId !== this.pointerId) return;
        if (event.type === 'pointercancel') {
          this.releasePointer(event.pointerId);
          this.pointerId = null;
          this.classList.remove('is-dragging');
          return;
        }
        const deltaX = event.clientX - this.pointerStartX;
        const deltaY = event.clientY - this.pointerStartY;
        if (this.scale <= 1 && Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          this.step(deltaX < 0 ? 1 : -1);
          this.armClickSuppression();
        } else if (this.scale > 1 && this.pointerMoved) {
          this.armClickSuppression();
        }
        this.releasePointer(event.pointerId);
        this.pointerId = null;
        this.classList.remove('is-dragging');
      }

      releasePointer(pointerId) {
        if (!this.viewport?.hasPointerCapture?.(pointerId)) return;
        this.viewport.releasePointerCapture(pointerId);
      }

      toggleZoom(clientX, clientY) {
        if (this.scale > 1) {
          this.setZoom(1);
          return;
        }
        const image = this.content?.querySelector('img');
        const rect = image?.getBoundingClientRect();
        if (rect?.width && rect?.height && Number.isFinite(clientX) && Number.isFinite(clientY)) {
          const originX = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
          const originY = Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100));
          image.style.setProperty('--mt-fp-lightbox-origin-x', `${originX}%`);
          image.style.setProperty('--mt-fp-lightbox-origin-y', `${originY}%`);
        }
        this.setZoom(3, { preserveOrigin: true });
      }

      setZoom(scale, { preserveOrigin = false } = {}) {
        const image = this.content?.querySelector('img');
        if (!image) return;
        this.scale = scale > 1 ? 3 : 1;
        if (!preserveOrigin || this.scale === 1) {
          image.style.setProperty('--mt-fp-lightbox-origin-x', '50%');
          image.style.setProperty('--mt-fp-lightbox-origin-y', '50%');
        }
        if (this.scale === 1) {
          this.panX = 0;
          this.panY = 0;
        }
        image.style.setProperty('--mt-fp-lightbox-scale', String(this.scale));
        this.setPan(this.panX, this.panY);
        this.classList.toggle('is-zoomed', this.scale > 1);
      }

      setPan(x, y) {
        const image = this.content?.querySelector('img');
        if (!image) return;
        const maxX = Math.max(0, (image.clientWidth * (this.scale - 1)) / 2);
        const maxY = Math.max(0, (image.clientHeight * (this.scale - 1)) / 2);
        this.panX = Math.max(-maxX, Math.min(maxX, x));
        this.panY = Math.max(-maxY, Math.min(maxY, y));
        image.style.setProperty('--mt-fp-lightbox-x', `${this.panX}px`);
        image.style.setProperty('--mt-fp-lightbox-y', `${this.panY}px`);
      }

      armClickSuppression() {
        window.clearTimeout(this.suppressClickTimer);
        this.suppressClick = true;
        this.suppressClickTimer = window.setTimeout(() => {
          this.suppressClick = false;
        }, 700);
      }

      resetTransform() {
        this.scale = 1;
        this.panX = 0;
        this.panY = 0;
        this.pointerId = null;
        this.suppressClick = false;
        this.classList.remove('is-zoomed', 'is-dragging');
      }

      reset() {
        this.intent += 1;
        window.clearTimeout(this.suppressClickTimer);
        this.resetTransform();
        this.restoreMountedMedia();
        this.content?.replaceChildren();
        this.entries = [];
      }
    }

    customElements.define('mt-fast-product-lightbox', MtFastProductLightbox);
  }
  } catch(e) { console.error(e); }
})();

})();
